/*
  Medición. No carga nada hasta que haya un identificador en
  KALLPA.medicion (js/config.js). Con un identificador puesto, carga la
  herramienta correspondiente y le envía los mismos eventos:
    capitulo        llegó a un capítulo
    panel           abrió un panel
    add_to_cart     agregó al carrito
    begin_checkout  tocó "Finalizar compra"
    contact         tocó un enlace de WhatsApp
*/
(function () {
  'use strict';
  var ids = (window.KALLPA && window.KALLPA.medicion) || {};

  function cargar(src) {
    var s = document.createElement('script');
    s.async = true; s.src = src;
    document.head.appendChild(s);
  }

  if (ids.ga4) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', ids.ga4);
    cargar('https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(ids.ga4));
  }

  if (ids.metaPixel) {
    var fbq = window.fbq = function () { fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments); };
    window._fbq = fbq; fbq.push = fbq; fbq.loaded = true; fbq.version = '2.0'; fbq.queue = [];
    cargar('https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', ids.metaPixel);
    fbq('track', 'PageView');
  }

  if (ids.tiktokPixel) {
    var ttq = window.ttq = window.ttq || [];
    window.TiktokAnalyticsObject = 'ttq';
    ['page', 'track', 'identify'].forEach(function (m) {
      ttq[m] = function () { ttq.push([m].concat(Array.prototype.slice.call(arguments))); };
    });
    ttq._i = ttq._i || {}; ttq._i[ids.tiktokPixel] = []; ttq._i[ids.tiktokPixel]._u = 'https://analytics.tiktok.com/i18n/pixel/events.js';
    ttq._t = ttq._t || {}; ttq._t[ids.tiktokPixel] = +new Date();
    ttq._o = ttq._o || {}; ttq._o[ids.tiktokPixel] = {};
    cargar('https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=' + encodeURIComponent(ids.tiktokPixel) + '&lib=ttq');
    ttq.page();
  }

  // La compra termina en el checkout de Shopify, que esta página no ve. Para unirla con la visita, el carrito guarda
  // el identificador anónimo que Google Analytics le dio a este navegador (lo lee el píxel de compras de Shopify).
  window.KALLPA_idGoogle = function (cb) {
    var listo = false;
    var fin = function (v) { if (!listo) { listo = true; cb(v || null); } };
    if (!ids.ga4 || !window.gtag) return fin(null);
    try { window.gtag('get', ids.ga4, 'client_id', fin); } catch (err) { fin(null); }
    setTimeout(function () { fin(null); }, 2000);
  };

  var enMeta = { add_to_cart: 'AddToCart', begin_checkout: 'InitiateCheckout', contact: 'Contact' };

  window.KALLPA_medir = function (nombre, datos) {
    datos = datos || {};
    try {
      if (window.gtag) window.gtag('event', nombre, datos);
      var estandar = enMeta[nombre];
      var compra = { value: datos.value, currency: 'COP', content_name: 'COFFEE WORKOUT', quantity: datos.quantity };
      if (window.fbq) { if (estandar) window.fbq('track', estandar, compra); else window.fbq('trackCustom', nombre, datos); }
      if (window.ttq && window.ttq.track) window.ttq.track(estandar || nombre, estandar ? compra : datos);
    } catch (err) { /* la medición nunca debe romper la página */ }
  };
})();
